import React from "react";
import { createComponent, EventName } from "@lit/react";
import { BeamNonprofitSelectEvent } from "../../utils/events";
import { BeamRedeemTransaction as _BeamRedeemTransaction } from "./index";

export const BeamRedeemTransaction = createComponent({
  tagName: _BeamRedeemTransaction.tagName,
  elementClass: _BeamRedeemTransaction,
  react: React,
  events: {
    onNonprofitSelect: BeamNonprofitSelectEvent.eventName as EventName<BeamNonprofitSelectEvent>,
  },
});

export default BeamRedeemTransaction; // default alias for use with async import utils like next/dynamic and react.lazy
